import {
  FaUserCircle,
  FaHome,
  FaDice,
  FaHistory,
  FaWallet,
  FaQuestionCircle,
  FaUserFriends,
  FaEnvelope,
  FaUser,
  FaSignOutAlt,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { FaGlobe } from "react-icons/fa";
import { parseJWT } from "../../utils/jwtUtils";

const ResponsiveMenu = ({ showMenu }) => {
  const { t: translate, i18n } = useTranslation(["header"]);
  const handleLangChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };
  const currentLanguage = localStorage.getItem("i18nextLng") || "";
  const menuItems = [
    { icon: <FaHome />, label: translate("home"), href: "/" },
    {
      icon: <FaDice />,
      label: translate("Bingo_Game"),
      href: "/betamountpage",
    },
    { icon: <FaWallet />, label: translate("Wallet"), href: "/wallet" },
    { icon: <FaHistory />, label: translate("Game_History"), href: "/history" },
    {
      icon: <FaQuestionCircle />,
      label: translate("How_Play"),
      href: "/HowToPlay",
    },
    {
      icon: <FaUserFriends />,
      label: translate("Referral_Income"),
      href: "/referralIncome",
    },
  ];

  const userItems = [
    { icon: <FaUser />, label: translate("Profile"), href: "/profile" },
    {
      icon: <FaEnvelope />,
      label: translate("Contact_Us"),
      href: "https://t.me/zemedbingo",
    },
    { icon: <FaSignOutAlt />, label: translate("Log_out"), href: "/logout" },
  ];
  const handleLogout = (e) => {
    e.preventDefault(); // prevent default link navigation
    localStorage.removeItem("userInfo"); // remove user info if stored
    window.location.href = "/login"; // redirect to login page
  };
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);
  return (
    <div
      className={`${
        showMenu ? "left-0" : "-left-[100%]"
      } fixed bottom-0 top-0 z-20 flex h-screen w-[75%] flex-col justify-between bg-gradient-to-b from-cyan-950 via-cyan-800 to-cyan-950 px-6 pb-6 pt-32 text-white transition-all duration-300 md:hidden`}
    >
      <div>
        {/* User Info */}
        <div className="flex items-center gap-3 mb-4">
          <FaUserCircle size={50} className="text-blue-500" />
          <div>
            <h1 className="font-semibold text-lg font-serif">
              {userInfo?.username}
            </h1>
            <h2 className="text-sm text-slate-400 font-serif">
              {userInfo?.phone}
            </h2>
          </div>
        </div>

        {/* Main Navigation */}
        <nav>
          <ul className="flex flex-col gap-1">
            {" "}
            {/* Reduced gap here */}
            <hr className="my-2 border-t border-slate-500" />
            {menuItems.map((item, idx) => (
              <li key={idx}>
                <a
                  href={item.href}
                  className="font-serif flex items-center gap-2 py-1 px-3 rounded-lg hover:bg-blue-600/30 transition-colors duration-200"
                >
                  {item.icon}
                  <span className="font-medium font-serif">{item.label}</span>
                </a>
              </li>
            ))}
            {/* Divider */}
            <hr className="my-2 border-t border-slate-500" />
            <li className="relative">
              <label className="font-serif flex items-center gap-2 py-2 px-3 rounded-lg hover:bg-primary transition-colors duration-200 cursor-pointer">
                <FaGlobe /> {/* you can change icon, e.g. FaGlobe */}
                <span className="font-medium">
                  {currentLanguage === "en" ? "Language" : "ቋንቋ"}
                </span>
                {/* Hidden select */}
                <select
                  onChange={handleLangChange}
                  value={currentLanguage}
                  className="inset-0 w-full absolute opacity-0 cursor-pointer"
                >
                  <option value="en" className="text-black">
                    English
                  </option>
                  <option value="am" className="text-black">
                    አማርኛ
                  </option>
                </select>
              </label>
            </li>
            {userItems.map((item, idx) => (
              <li key={idx}>
                {item.label === "Log out" ? (
                  <button
                    onClick={handleLogout}
                    className="font-serif flex items-center gap-2 py-2 px-3 w-full text-left rounded-lg hover:bg-red-600/30 transition-colors duration-200"
                  >
                    {item.icon}
                    <span className="font-medium">{item.label}</span>
                  </button>
                ) : (
                  <a
                    href={item.href}
                    className="flex items-center gap-2 py-2 px-3 rounded-lg hover:bg-red-600/30 transition-colors duration-200"
                  >
                    {item.icon}
                    <span className="font-medium">{item.label}</span>
                  </a>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/* Footer */}
      <div className="text-center text-slate-500 text-xs mt-4 font-serif">
        {translate("All_Rights_Reserved")}
      </div>
    </div>
  );
};

export default ResponsiveMenu;
